import { render, staticRenderFns } from "./SaleTypeEditTexts.vue?vue&type=template&id=5aa9ac96"
import script from "./SaleTypeEditTexts.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditTexts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports